module.exports = __webpack_public_path__ + "static/serverBio2-e92a3d309cf448ecb914b98790d9e7fa.png";